function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// https://govuk-static.herokuapp.com/component-guide/search
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { LIGHT_BLUE, GREY_2, WHITE, YELLOW } from 'govuk-colours';
import { NTA_LIGHT } from '@govuk-react/constants';
import { Search } from '@govuk-react/icons';
import { withWhiteSpace } from '@govuk-react/hoc';
var SearchBoxWrapper = styled('div')({
  boxSizing: 'border-box',
  display: 'flex',
  width: '100%',
  background: WHITE
}); // css normalize is hiding the input:search clear SearchButton

var InputSearchBox = styled('input')({
  width: '100%',
  height: '40px',
  padding: '6px',
  margin: 0,
  border: "solid 1px " + GREY_2,
  borderRight: 0,
  boxSizing: 'border-box',
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  textTransform: 'none',
  fontSize: '16px',
  lineHeight: '1.75',
  background: WHITE,
  borderRadius: 0,
  WebkitAppearance: 'none',
  ':focus': {
    marginRight: '3px',
    outline: "3px solid " + YELLOW,
    outlineOffset: 0,
    ' ~ button': {
      width: '46px'
    }
  }
});
var SearchButton = styled('button')({
  backgroundColor: LIGHT_BLUE,
  border: 0,
  display: 'block',
  color: WHITE,
  position: 'relative',
  padding: '10px',
  width: '45px',
  height: '40px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '2px 50%',
  textIndent: '-999em',
  overflow: 'hidden',
  ':focus': {
    outline: "3px solid " + YELLOW,
    outlineOffset: 0
  }
});
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * import Layout from '@govuk-react/layout';
 * import GridRow from '@govuk-react/grid-row';
 * import GridCol from '@govuk-react/grid-col';
 *
 * <Layout>
 *    <GridRow>
 *      <GridCol>
 *        <SearchBox placeholder="Search GOV.UK">SearchBox example</SearchBox>
 *      </GridCol>
 *    </GridRow>
 *  </Layout>
 * ```
 *
 * ### References:
 * - https://govuk-static.herokuapp.com/component-guide/search
 *
 */

var SearchBox = function SearchBox(_ref) {
  var placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, ["placeholder"]);

  return React.createElement(SearchBoxWrapper, props, React.createElement(InputSearchBox, {
    type: "search",
    placeholder: placeholder
  }), React.createElement(SearchButton, {
    title: "Search"
  }, React.createElement(Search, {
    fill: WHITE
  })));
};

SearchBox.defaultProps = {
  placeholder: undefined
};
export default withWhiteSpace({
  marginBottom: 0
})(SearchBox);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/search-box/es/index.js
// module id = 276
// module chunks = 0